/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { mapBrandEnvToBrand, mapBrandToBrandInitial } from '@utils/brand';

import seo from './seo';

import { PublicConfig } from '@/types/app-config';

const brandName = mapBrandEnvToBrand(process.env.BRAND);

const publicConfig: PublicConfig = {
  brandName,
  brandInitial: mapBrandToBrandInitial(brandName),
  version: process.env.NEXT_PUBLIC_VERSION,
  graphqlUrl: process.env.NEXT_PUBLIC_GRAPHQL_URL,
  seo,
};

export default publicConfig;
